module.exports = __webpack_public_path__ + "img/0.25.198132e2.png";